<script>
import {useWebSocket} from "@/store/useWs"
import {randomWsUrl} from "@/utils/config"
import { customAlphabet }  from "nanoid"
export default {
    name: "DouyinQrcode",
    props: {},
    data() {
        return {
            visible: false,
            imgSrc: "",
            wsIns: null,
            loading: null,
            intervalIns: null,
            smsSec: 2000,
            smsStatus: false,
            verifyCode: "",
            mobile: "",
            countDownIns: null,
            secVal: 60,
            cookieVal: "",
        }
    },
    computed: {
        title() {
            return this.smsStatus ? "接收短信验证" : "扫码授权抖音"
        }
    },
    methods: {
        createLoading(msg="加载中...") {
            this.loading && this.loading.close(); //先清空原来的
            this.loading = this.$loading({
                lock: true,
                text: msg,
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)'
            })
        },
        closeDialog() {
            this.visible = false
            this.clearSMS()
            this.sendMsg("close")
            console.log("close")
            this.wsIns?.close();
            this.smsStatus = false
        },
        openDialog() {
            this.handlerWs();
        },
        intervalSMS() {
            this.clearSMS()
            this.intervalIns = setInterval(() => {
                this.sendMsg("sms", {}, false)
            }, this.smsSec)
        },
        clearSMS() {
            this.intervalIns && clearInterval(this.intervalIns)
        },
        sendMsg(type, data={}, loading = true) {
            data = {
                type,
                data: {
                    id: Number(localStorage.getItem("id")),
                    ...data
                }
            }
            if (type !== "close") {
                loading && this.createLoading()
            }
            this.wsIns && this.wsIns.send(JSON.stringify(data))
        },
        bindDriver() {
            // const min = 1024;
            // const max = 65535;
            // const port = Math.floor(Math.random() * (max - min + 1)) + min;
            this.sendMsg("init")
        },
        refreshHandle() {
            //重新请求二维码
            this.clearSMS()
            this.sendMsg("webdriver")
        },
        verifyCodeHandle() {
            this.sendMsg("verify", {data: {verify_code: this.verifyCode}})
        },
        countDownSec() {
            clearInterval(this.countDownIns)
            this.countDownIns = setInterval(() => {
                if (this.secVal < 2) {
                    clearInterval(this.countDownIns)
                    this.secVal = 60
                } else {
                    this.secVal--
                }
            }, 1000)
        },
        resendVerifyCode() {
            this.sendMsg("resend")
            this.countDownSec()
        },
        handlerMessage(msg) {
            console.log("msg",msg)
            if (msg === "pong") {
                return
            }
            try {
                const result = JSON.parse(msg)
                if (result.data.sms === false) {
                    return;
                }

                this.loading && this.loading.close();
                if (result.data.close) {
                    this.closeDialog()
                    this.$message.warning(result.msg)
                    return
                }
                if (result.data?.type === "notice") {
                    this.createLoading(result.msg);
                }

                console.log("result", result)
                if (result.code !== 200) {
                    this.$message.warning(result.msg)
                    this.closeDialog()
                    return;
                }
                //发起浏览器模拟启动
                // if (result.data.driver) {
                //     this.sendMsg("init")
                // }
                //发起获取二维码
                if (result.data.status) {
                    this.sendMsg("webdriver")
                }
                //显示二维码
                if (result.data.qrcode_url) {
                    this.imgSrc = result.data.qrcode_url
                    this.visible = true;
                    this.smsStatus = false;
                    this.verifyCode = "";
                    this.intervalSMS()
                }
                //短信验证
                if (result.data.sms) {
                    this.createLoading("发起短信验证...");
                    this.clearSMS()
                    this.sendMsg("mobile")
                }
                //显示验证码输入框
                if (result.data.mobile) {
                    this.mobile = result.data.mobile
                    this.smsStatus = true;
                    this.countDownSec();
                }
                //登录操作
                if (result.data.verify) {
                    this.sendMsg("login")
                }
                //重新发送验证码成功
                if (result.data.resend) {
                    this.countDownSec();
                }
                //登录成功
                if (result.data?.cookie) {
                    console.log("cookie", result.data.cookie)
                    this.cookieVal = result.data.cookie
                    this.$emit("update-data", this.cookieVal);
                    this.closeDialog()
                }


            } catch (e) {
                this.loading && this.loading.close();
                console.log("ERROR: ", e)
                this.$message.warning("消息格式异常")
            }
        },
        handlerWs() {
            this.wsIns = useWebSocket(
                randomWsUrl(localStorage.getItem("id")),
                () => this.bindDriver(),
                this.handlerMessage,
            )
        }
    },
    beforeDestroy() {
        this.clearSMS()
        clearInterval(this.countDownIns)
        this.wsIns?.close();
    }
}
</script>
<template>
    <div class="douyin-qrcode-container">
        <el-dialog :visible.sync="visible" width="40%" :title="title" @closed="closeDialog">
            <div class="qrcode-container" v-if="!smsStatus">
                <div class="qrcode-img">
                    <img :src="imgSrc" alt="">
                </div>
                <div class="qrcode-tip">
                    打开「抖音APP」点击左上角
                    <div class="icon-box">
                        <i class="iconfont">&#xe687;</i>
                    </div>
                    进行扫一扫&nbsp;&nbsp;
                    <el-link type="primary" icon="el-icon-refresh-right" :underline="false" @click="refreshHandle">刷新二维码</el-link>
                </div>
            </div>
            <div class="qrcode-container" v-else>
                <div class="sms-title">
                    <span>短信已发送至<span class="bold">{{ mobile }}</span></span>
                </div>
                <div class="sms-input">
                    <el-input placeholder="请输入验证码" v-model="verifyCode" >
                        <el-button slot="append" :disabled="secVal !== 60" @click="resendVerifyCode">{{ secVal == 60 ? '重新发送' : `${secVal}s后重新发送`}}</el-button>
                    </el-input>
                </div>
                <div class="sms-btn-list">
                    <el-button class="w-120" @click="closeDialog">取消</el-button>
                    <el-button type="primary" class="w-120" @click="verifyCodeHandle">验证</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<style scoped lang="scss">
.douyin-qrcode-container {
    &, & * {
        box-sizing: border-box;
    }
    .qrcode-container {
        .sms-title {
            margin-bottom: 20px;
            font-size: 14px;
            color: #84858B;
            span.bold {
                font-weight: 600;
                color: #000;
                margin-left: 8px;
            }
        }
        .sms-input {
            margin-bottom: 20px;
        }
        .sms-btn-list {
            .w-120 {
                width: 120px;
            }
        }
        width: 100%;
        height: 350px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .qrcode-img {
            width: 250px;
            height: 250px;
            border: 1px solid #eee;
            border-radius: 10px;
            padding: 10px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .qrcode-tip {
            margin-top: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #16182357;
            .icon-box {
                border: 1px solid #16182357;
                width: 16px;
                height: 16px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 50%;
                margin: 0 5px;
                .iconfont {
                    font-size: 8px;
                }
            }
        }
    }

}

</style>
